<template>
  <div>
    <!-- <pre>{{courseContent}}</pre> -->
    <!-- Tab : {{parent_tab}}
    user_course_answer_master_id : {{user_course_answer_master_id}} -->
    <!-- {{client_user_id}} -->
      <vs-tabs class="cstm-card" v-model="parent_tab">

        <vs-tab
          label="Homework"
          icon-pack="feather"
          icon="icon-file-text"
        >
        <!-- <pre>{{homeworkData[0].assignment.questions[0].student_answers_new}}</pre> -->
          <assignment-modal
            :lessonAssignment="homeworkData"
            :sectionType="1"
            :platform_customer_id="courseContent.platform_customer_id"
          ></assignment-modal>
        </vs-tab>

        <vs-tab
          label="Exams"
          icon-pack="feather"
          icon="icon-file-text"
        >
          <assignment-modal
            :lessonAssignment="examData"
            :sectionType="1"
            :platform_customer_id="courseContent.platform_customer_id"
          ></assignment-modal>
        </vs-tab>

          <vs-tab
          label="Reports"
          icon-pack="feather"
          icon="icon-file-text"
        >
          <assignment-modal
            :assignmentType="'report'"
            :lessonAssignment="reportData"
            :sectionType="1"
            :platform_customer_id="courseContent.platform_customer_id"
          ></assignment-modal>
        </vs-tab>

         <!-- <vs-tab
          label="Generate Gradebook"
          icon-pack="feather"
          icon="icon-file-text"
        > 
          <generate-gradebook
            :course_data="courseContent"
            :client_user_id="client_user_id"
          ></generate-gradebook>
        </vs-tab> -->

      </vs-tabs>
       <vs-divider/>
      <vs-button class="block mx-auto" @click="saveGrade" v-if="parent_tab === 0">Save Homework Grade</vs-button>
      <vs-button class="block mx-auto" @click="saveGrade" v-if="parent_tab === 1">Save Exam Grade</vs-button>
      <vs-button class="block mx-auto" @click="saveReport" v-if="reportData.length && parent_tab === 2">Save Report</vs-button>
      <vs-divider v-if="reportData.length && parent_tab === 2"/>
      <vs-button class="block mx-auto" @click="generateGradebook()" v-if="parent_tab === 2">Generate Gradebook</vs-button>
  </div>
</template>

<script>
import QuestionModal from './QuestionModal.vue'
import AssignmentModal from './AssignmentModal.vue'
import GenerateGradebook from './GenerateGradebook.vue'
import axios from 'axios'
import { studentAnswersRemark, studentAnswersRemarkReport, studentGradebook } from '@/api/grade'
import {EventBus} from '../mixin/EventBus'
// import { readFile } from 'xlsx/types'

export default {
  data () {
    return {
      homeworkData:[],
      examData:[],
      reportData:[],
      parent_tab:0
    }
  },
  mixins: [EventBus],
  props: {
    courseContent: {
      required: true,
      default: () => {}
    },
    user_course_answer_master_id: {
      required: true
    },
    client_user_id: {
      required: true
    }
  },
  components: {
    QuestionModal,
    AssignmentModal,
    GenerateGradebook
  },
  watch: {
 
  },
  mounted () {
  },
  created () {

    this.homeworkData = this.courseContent.courseAssignments.filter(ele => {
      return ele.assignment.assignment_type_id === 2
    })

    this.examData = this.courseContent.courseAssignments.filter(ele => {
      return ele.assignment.assignment_type_id === 4
    })

    this.reportData = this.courseContent.courseAssignments.filter(ele => {
      return ele.assignment.assignment_type_id === 3
    })
    
    // 

  },
  methods: {
    
    generateGradebook () {
      const client_user_id = this.client_user_id
      const course_id =  this.courseContent.course_id
      const payload = {
        client_user_id,
        course_id
      }
      //console.log(payload)
      this.studentGradebook(payload)
    },
    async studentGradebook (payload) {
      try {
        this.$vs.loading()
        this.attendance_details = []
        this.homework_details = []
        this.exam_details = []
        this.report_details = []
        const customer_id = this.$store.getters.customerId
        const {data} = await studentGradebook(customer_id, payload)
        this.$vs.notify({
          title: 'Gradebook generated',
          text: 'Redirecting to gradebook...',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        setTimeout(() => {
          this.$router.push({name: 'gradebook', params: { payload}})
        }, 2000)
        
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          title: 'Error',
          text: e,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })

      } finally {
        this.$vs.loading.close()
      }
    },
  
    async saveReport () {
      
      this.$vs.loading({
        text: 'Updating marks...'
      })
        
      const all_data = [...this.reportData]
      const all_marks = all_data.map((x) => { 
        return x.assignment.questions.map((y) => {
          return y
        }).filter(Boolean) 
      }) 

      const all_marks_merged = [].concat.apply([], all_marks)
      
      setTimeout(async () => {
        try {
          const payload = {
            report_comments:[]
          }
          for (let i = 0; i < all_marks_merged.length; i++) {
            let question_answer = null 
            if (all_marks_merged[i].questions_options.length) {
              question_answer = all_marks_merged[i].questions_options.filter((x) => { return x.id === all_marks_merged[i].student_answers_new.assignment_question_answer_id })
            }

            if (question_answer !== null && question_answer.length) {
              question_answer = question_answer[0].option_name
            } else {
              question_answer = all_marks_merged[i].student_answers_new.short_answer
            }

            //If question is of checkbox type or multiselect dropdown
            if (all_marks_merged[i].question_input_type_id === 5 || all_marks_merged[i].question_input_type_id === 6) {
              question_answer = all_marks_merged[i].questions_options.map((x) => {
                if (all_marks_merged[i].student_answers_new.assignment_question_answer_id.includes(x.id)) {
                  return x.option_name
                } 
              }).filter(Boolean)
              question_answer = question_answer.join('\n')
            }
            
            
            payload.report_comments[i] = {    
              'user_course_answer_master_id': this.user_course_answer_master_id,
              'assignment_builder_id': all_marks_merged[i].assignment_builder_id,
              'assignment_question_id': all_marks_merged[i].id,
              'question_title': all_marks_merged[i].title,
              question_answer,
              'question_answer_id': [all_marks_merged[i].student_answers_new.assignment_question_answer_id],
              'feedback_text' : all_marks_merged[i].student_answers_new.teacher_comment
            }
          }
          const customer_id = this.$store.getters.customerId
          const {data} = await studentAnswersRemarkReport(customer_id, payload)
          
          this.$vs.notify({
            title: 'Success',
            text: 'Report saved successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 3000
          })
        } catch (e) {
          
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to save report',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'error',
            time: 3000
          })
        } finally {
          this.$vs.loading.close()
        }
      }, 1000)
    },
    saveGrade () {
      this.$vs.loading({
        text: 'Updating marks...'
      })
        
      const all_data = [...this.homeworkData, ...this.examData, ...this.reportData]
      const all_marks = all_data.map((x) => { 
        return x.assignment.questions.map((y) => {
          if (y.student_answers_new.student_answer_id !== null) {
            return y.student_answers_new 
          } 
        }).filter(Boolean) 
      }) 

      const all_marks_merged = [].concat.apply([], all_marks)
      setTimeout(async () => {
        try {
          const payload = {
            marks:[]
          }
          for (let i = 0; i < all_marks_merged.length; i++) {
            payload.marks[i] = {
              'student_answer_id' : all_marks_merged[i].student_answer_id,
              'mark' : Number(all_marks_merged[i].mark),
              'teacher_comment':  all_marks_merged[i].teacher_comment,
              'assignment_type_id' : all_marks_merged[i].assignment_type_id
            }
          }

          const customer_id = this.$store.getters.customerId
          const {data} = await studentAnswersRemark(customer_id, payload)
          
          this.$vs.notify({
            title: 'Success',
            text: 'Marks updated successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 3000
          })

        } catch (e) {
          
          this.$vs.notify({
            title: 'Error',
            text: 'Marks update failed',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 3000
          })
        } finally {
          this.$vs.loading.close()
        }
      }, 1000)
    },
    redirectNextLesson () {
      
      this.$emit('backToLesson', 0)
    },
    saveComplete (courseId) {
      
      const payload = {
        course_id: courseId,
        type: 1
      }

      const isMarkDone = this.markComplete(payload)
      if (isMarkDone) {
        
        this.courseContent.courseComplete = 1
      }
    },
    downloadImage (item) {
      
      axios({
        url: `https://cors-anywhere.herokuapp.com/${item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      })
        .then((response) => {
          const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileUrl

          fileLink.setAttribute('download', item.file_name)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch((error) => {
          
        })
        .finally(() => {
          
        })
    }
  }
}
</script>